import React from 'react';
import { HeaderCell, HeaderTitle } from './styled';

interface TableHeaderProps {
  title: string;
  paddingLeft?: string;
}

export const TableHeader = ({ title, paddingLeft = '16px' }: TableHeaderProps) => {
  return (
    <HeaderCell style={{ paddingLeft }}>
      <HeaderTitle>{title}</HeaderTitle>
    </HeaderCell>
  );
};
